/** Shared DropdownMenu props for competitive host player action menus (Courts ⋯ + Manage Actions). */
export const COMPETITIVE_HOST_PLAYER_MENU_PROPS = {
  align: 'right',
  usePortal: true,
  useMobileSheet: false,
  disabledHintMode: 'tooltip',
};
